import type { FC } from 'react';
import type { VolatilitySmileProps } from './types';
import VolatilitySmileWidget from './volatility-smile-widget';
import { GetVolProvider } from '../../../../providers/get-vol-provider';
import { DataLabelEnum } from '../../../../model/data_label.enum';
import { VolSmileDataType, VolSmileProvider } from '../../../../providers/widgets';

const VolatilitySmileWrapperProvider: FC<VolatilitySmileProps> = (props) => (
  <GetVolProvider label={DataLabelEnum.PERPETUAL} providerKey={props.providerKey}>
    <VolSmileProvider dataType={VolSmileDataType.volSmile} providerKey={props.providerKey}>
      <VolatilitySmileWidget {...props} />
    </VolSmileProvider>
  </GetVolProvider>
);

export default VolatilitySmileWrapperProvider;
